"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultibarChart = void 0;
var drawPlane_1 = require("../parse/drawPlane");
var getPlanes_1 = require("../parse/getPlanes");
var getIndexNearest_1 = require("../../common/getIndexNearest");
var createSvg_1 = require("../createSvg");
var MultibarChart = function (svg, config) {
    var thicknessTotal = config.thickness || 6;
    var innerPaddingStart = config.xAxis.innerPaddingStart || 0;
    var _a = getPlanes_1.getPlanes(config), dataPointGroup = _a.dataPointGroup, yAxisMarks = _a.yAxisMarks, destPlane = _a.destPlane;
    var dataPointGroup2 = dataPointGroup;
    var thickness = Math.ceil(thicknessTotal / dataPointGroup2.length);
    drawPlane_1.drawPlane(svg, config, dataPointGroup2[0], yAxisMarks, destPlane);
    if (config.selectedIndex > -1 && dataPointGroup2.length && dataPointGroup2[0][config.selectedIndex]) {
        var selectLine = destPlane[1];
        var newX = Math.floor(dataPointGroup2[0][config.selectedIndex][0] + thicknessTotal / 2) + innerPaddingStart;
        selectLine[0][0] = newX;
        selectLine[1][0] = newX;
        svg.line(selectLine).stroke({ color: config.selectedLineColor, width: 1 });
    }
    dataPointGroup2.map(function (it0, h) {
        it0.map(function (it, i) {
            var height = destPlane[0][0][1] - it[1];
            var color = (i === config.selectedIndex && config.values[0].color2) ? config.values[h].color2 : config.values[h].color;
            return svg.rect(thickness, height).move(innerPaddingStart + it[0] + thickness * (h), it[1] - 1).fill(color);
        });
    });
    var getXY = function (x, y) { return getIndexNearest_1.getIndexNearest(dataPointGroup2, thickness, x, y); };
    var getPopupInfo = function (i) {
        var color = config.values[0].color;
        var title = config.yAxis.label2 ? config.yAxis.label2 : config.yAxis.label;
        var value = createSvg_1.comma(config.values[0].series[i]);
        return {
            title: config.xAxis.series[i],
            rows: [{ color: color, title: title, value: value }]
        };
    };
    var getDataPointGroup = function () { return dataPointGroup2; };
    return { svg: svg, getXY: getXY, getPopupInfo: getPopupInfo, getDataPointGroup: getDataPointGroup };
};
exports.MultibarChart = MultibarChart;
